module.exports = __webpack_public_path__ + "static/media/Pit Pay Collapsed Menu Logo.2ffff76d.svg";